export const DEFAULT_LOCALE = 'en';

type AppLocale = { path: string; locale: string; default?: boolean };

export const appLocales: Record<string, AppLocale> = {
  en: {
    path: 'en',
    locale: 'English',
    default: true,
  },
  zh: {
    path: 'zh',
    locale: '中文',
  },
  ru: {
    path: 'ru',
    locale: 'Русский',
  },
  es: {
    path: 'es',
    locale: 'Español',
  },
  /*
  ja: {
    path: 'ja',
    locale: '日本語',
  },
  ko: {
    path: 'ko',
    locale: '한국어',
  },
  fr: {
    path: 'fr',
    locale: 'Français',
  },
  */
};
